import React, { Component } from "react"
import PropTypes from "prop-types"
import { Button, Card, Heading, Page, Stack, TextStyle, Thumbnail } from "@shopify/polaris"
import suggests from "../../components/WishlistApp/Suggests/suggests"
import Switch from "react-switch"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import Actions from "../../actions"
let clientUrl1 = "electro-5-demo.myshopify.com"
let clientUrl2 = "electro-theme-2019.myshopify.com"
let clientUrl3 = "ltp-123.myshopify.com"
function mapStateToProps(state) {
    return {
        app_settings: state.app_settings,
        app_render: state.app_render,
        app_edited: state.app_edited,
        plan: state.plan,
        compare_custom: state.compare_custom,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    }
}

class IntegrationPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            app_1: false,
            app_2: false,
            app_3: false,
            app_settings: JSON.parse(JSON.stringify(props.app_render)),
            wishlist_settings_edited: JSON.parse(
                JSON.stringify(this.props.app_edited.wishlist_settings_edited),
            ),
            compare_settings_edited: JSON.parse(
                JSON.stringify(this.props.app_edited.compare_settings_edited),
            ),
            general_settings_edited: JSON.parse(
                JSON.stringify(this.props.app_edited.general_settings_edited),
            ),
        }
    }

    componentDidMount() {
        if (
            this.props.compare_custom.isInstall /*&&
            (window.parentUrl == clientUrl1 ||
                window.parentUrl == clientUrl2 ||
                window.parentUrl == clientUrl3)*/
        ) {
            this.setState({ app_1: true })
        }
        if (this.props.compare_custom.isInstallAT) {
            this.setState({ app_2: true })
        }
    }

    /**
     * Cache edited setting
     */
    cacheSetting(type: String, editObj: Object) {
        const settingKey =
            type === "wishlist"
                ? "wishlist_settings"
                : type === "compare"
                ? "compare_settings"
                : "general_settings"
        const editObjKey = Object.keys(editObj)[0]
        const editObjVal = Object.values(editObj)[0]
        const { app_settings, actions } = this.props
        const { wishlist_settings_edited, compare_settings_edited, general_settings_edited } =
            this.state
        const handleList =
            type === "wishlist"
                ? wishlist_settings_edited
                : type === "compare"
                ? compare_settings_edited
                : general_settings_edited
        const handleKey =
            type === "wishlist"
                ? "wishlist_settings_edited"
                : type === "compare"
                ? "compare_settings_edited"
                : "general_settings_edited"
        const propObjVal = app_settings[settingKey][editObjKey]
        let compareFlag = false
        if (!Array.isArray(editObjVal)) {
            // Normal value
            if (typeof editObjVal !== "object") {
                if (editObjVal === propObjVal) {
                    compareFlag = true
                }
            }
            // Object value
            else {
                if (
                    JSON.stringify({
                        ...this.state.app_settings[settingKey][editObjKey],
                        ...editObjVal,
                    }) === JSON.stringify(propObjVal)
                ) {
                    compareFlag = true
                }
            }
        } else {
            editObjVal.sort()
            propObjVal.sort()
            if (editObjVal.join() === propObjVal.join()) {
                compareFlag = true
            }
        }

        let newList = []
        let checkItemExisted = handleList.findIndex((item) => {
            let itemKey = Object.keys(item)[0]
            return itemKey === editObjKey
        })

        if (!compareFlag) {
            if (checkItemExisted !== -1) {
                newList = handleList.map((item) => {
                    let itemKey = Object.keys(item)[0]
                    if (itemKey === editObjKey) {
                        if (typeof editObjVal === "object" && !Array.isArray(editObjVal)) {
                            return {
                                [editObjKey]: {
                                    ...this.state.app_settings[settingKey][editObjKey],
                                    ...editObjVal,
                                },
                            }
                        } else {
                            return editObj
                        }
                    } else {
                        return item
                    }
                })
            } else {
                if (typeof editObjVal === "object" && !Array.isArray(editObjVal)) {
                    newList = handleList.concat([
                        {
                            [editObjKey]: {
                                ...this.state.app_settings[settingKey][editObjKey],
                                ...editObjVal,
                            },
                        },
                    ])
                } else {
                    newList = handleList.concat([editObj])
                }
            }
        } else {
            newList = handleList.filter((item) => {
                let itemKey = Object.keys(item)[0]
                return itemKey !== editObjKey
            })
        }

        this.setState({
            [handleKey]: newList,
        })
        actions.changeAppEditedAction(handleKey, newList)
        this.changeSetting()
    }

    handleChangeCustomeCompare(key, val) {
        this.setState({
            app_settings: {
                ...this.state.app_settings,
                compare_settings: {
                    ...this.state.app_settings.compare_settings,
                    [key]: val,
                },
            },
        })

        // Cache edited setting
        this.cacheSetting("compare", { [key]: val })
    }

    /** Change general setting **/
    handleChangeGeneralSettings(key, val) {
        this.setState({
            app_settings: {
                ...this.state.app_settings,
                general_settings: {
                    ...this.state.app_settings.general_settings,
                    [key]: val,
                },
            },
        })
        this.cacheSetting("general", { [key]: val })
    }

    changeSetting() {
        const { actions } = this.props
        setTimeout(() => {
            actions.changeAppRenderAction("general", this.state.app_settings.general_settings)
            actions.changeAppRenderAction("wishlist", this.state.app_settings.wishlist_settings)
            actions.changeAppRenderAction("compare", this.state.app_settings.compare_settings)
        })
    }

    render() {
        const { app_1, app_2, app_3, app_settings } = this.state
        const { compare_settings, general_settings } = app_settings
        return (
            <div>
                <Page title="Other Supported Apps">
                    <div className="standard mt-50">
                        <div className="standard-left">
                            <Stack vertical className="standard-left">
                                <TextStyle variation="strong">Partner Apps</TextStyle>
                                <TextStyle variation="subdued">
                                    Infinite Options is proud to work closely with the following
                                    apps and services.
                                </TextStyle>
                            </Stack>
                        </div>
                        <div className="standard-right">
                            <Stack vertical>
                                {suggests.map((item, index) => (
                                    <Card sectioned key={index}>
                                        <Stack alignment="center">
                                            <Stack.Item>
                                                <Thumbnail source={item.logo} alt={item.title} />
                                            </Stack.Item>
                                            <Stack.Item fill>
                                                <Stack
                                                    alignment="center"
                                                    distribution="equalSpacing"
                                                >
                                                    <Stack.Item>
                                                        <p>{item.title}</p>
                                                        <p>{item.subtitle}</p>
                                                    </Stack.Item>
                                                    <Stack.Item>
                                                        {index === 0 ? (
                                                            app_1 ? (
                                                                <Switch
                                                                    height={20}
                                                                    width={46}
                                                                    onChange={() =>
                                                                        this.handleChangeCustomeCompare(
                                                                            "custom_compare",
                                                                            !compare_settings.custom_compare,
                                                                        )
                                                                    }
                                                                    checked={
                                                                        compare_settings.custom_compare
                                                                    }
                                                                />
                                                            ) : (
                                                                <a
                                                                    href={item.url}
                                                                    target="_blank"
                                                                    rel="noopener"
                                                                >
                                                                    <Button>Get app</Button>
                                                                </a>
                                                            )
                                                        ) : (
                                                            ""
                                                        )}
                                                        {index === 1 ? (
                                                            app_2 ? (
                                                                <Switch
                                                                    height={20}
                                                                    width={46}
                                                                    onChange={() =>
                                                                        this.handleChangeGeneralSettings(
                                                                            "isActiveAT",
                                                                            !general_settings.isActiveAT,
                                                                        )
                                                                    }
                                                                    checked={
                                                                        general_settings.isActiveAT
                                                                    }
                                                                />
                                                            ) : (
                                                                <a
                                                                    href={item.url}
                                                                    target="_blank"
                                                                    rel="noopener"
                                                                >
                                                                    <Button>Get app</Button>
                                                                </a>
                                                            )
                                                        ) : (
                                                            ""
                                                        )}
                                                        {index == 2 && (
                                                            <a
                                                                href={item.url}
                                                                target="_blank"
                                                                rel="noopener"
                                                            >
                                                                <Button>Get app</Button>
                                                            </a>
                                                        )}
                                                    </Stack.Item>
                                                </Stack>
                                            </Stack.Item>
                                        </Stack>
                                    </Card>
                                ))}
                            </Stack>
                        </div>
                    </div>
                </Page>
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(IntegrationPage)
